var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_qrcode"},[_c('div',{staticClass:"default"},[(_vm.hasUrl)?_c('img',{staticClass:"hechengqrcode",attrs:{"src":_vm.imageUrl+_vm.qrcodeUrl,"alt":""}}):_c('div',{},[_vm._v("无")])])])}
var staticRenderFns = []

export { render, staticRenderFns }